// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_b8-0";
export var orangeButton = "_b8-1";